
import React ,{useState} from 'react'
import './navbar.css'
import {RiMenu3Line,RiCloseLine} from 'react-icons/ri'
import logo from '../../assets/en.svg';

const Menu =() =>(
  <>
  <p><a href='#home'>Home</a></p>
  <p><a href='#wjs'>Why join Us</a></p>
  <p><a href='#possibility'>On-Demand</a></p>
  <p><a href='#features'>Case Studies</a></p>
  <p><a href='#blog'>Library</a></p>
  </>

)
const Navbar = () => {
  const [toggleMenu,setToggleMenu] = useState(false);
  return (
    <div className='yellow__navbar'>
      <div className='yellow__navbar-links'>
        <div className='yellow__navbar-links_logo'>
          <img src={logo} alt='logo'/>
        </div>
        <div className='yellow__navbar-links_container'>
          <Menu/>
        </div>
      </div>
      <div className='yellow__navbar-sign'>
        <p>Sign in</p>
        <button type='button'>Sign up</button>
      </div>
      <div className='yellow__navbar-menu'>
      {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
          <div className='yellow__navbar-menu_container scale-up-center'>
            <div yellow__navbar-menu_container-links>
              <Menu/>
              <div className='yellow__navbar-menu_container-links-sign'>
                <p>Sign in</p>
                <button type='button'>Sign up</button>
              </div>
            </div>
          </div>)}
      </div>
    </div>
  )
}

export default Navbar